import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import {} from 'react-i18nify';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Translate, translate } from 'react-i18nify';
import { account } from '../reducers/account';
import { Typography } from '@material-ui/core';

const style = theme => ({
  statusBanner: {
    padding: '10px',
    fontSize: '15px',
    color: '#333333',
    backgroundColor: theme.statusColors.error,
    margin: '10px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  statusMessage: {
    alignText: 'center',
    flexGrow: 1,
  },
  statusMessageTextBold: {
    fontWeight: 'bold',
    paddingTop: '4px',
    paddingBottom: '4px',
  },
  statusHelpMesage: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  button: {
    display: 'flex',
    gap: 2,
  },
});

class StatusBannerComponent extends Component {
  render() {
    const {
      classes,
      accountId,
      showButton = false,
      migrateRedirect,
      readOnlyDate,
      readOnlyState,
      generateMigrateLink,
      migrateStatus,
      migrateAction,
      migrateLink,
      isMigrated,
      checkAccountStatus,
    } = this.props;

    const redirectSecureEdge = () => {
      window.location.href = migrateRedirect;
    };

    const migrate_btn = () => {
      generateMigrateLink({
        account_id: accountId,
        individual: true,
      });
    };

    const statusMessage = showButton
      ? 'components.migrationToSecureEdge.notification.body'
      : 'components.migrationToSecureEdge.notification.mspBody';

    const readOnlyMessage = readOnlyState
      ? 'components.migrationToSecureEdge.migratedAccount.readOnlyMessage'
      : 'components.migrationToSecureEdge.migratedAccount.message';

    if (showButton && migrateAction === 'prepare') {
      //sleep for 15 seconds before making the request
      setTimeout(() => {
        checkAccountStatus();
      }, 15000);
    }

    return (
      <Box className={classes.statusBanner}>
        <Box className={classes.statusMessage}>
          {showButton && !isMigrated && migrateAction !== 'not_started' ? (
            <Translate
              value={`components.migrationToSecureEdge.${migrateAction}Message`}
            />
          ) : (
            <Box>
              {isMigrated ? (
                <>
                  <Typography className={classes.statusMessageTextBold}>
                    <Translate value="components.migrationToSecureEdge.migratedAccount.title" />
                  </Typography>
                  {translate(readOnlyMessage, { date: readOnlyDate })}
                  <Typography className={classes.statusMessageTextBold}>
                    <Translate value="components.migrationToSecureEdge.migratedAccount.help" />
                  </Typography>
                </>
              ) : (
                <Box className={classes.statusHelpMesage}>
                  <Typography className={classes.statusMessageTextBold}>
                    <Translate value="components.migrationToSecureEdge.notification.title" />
                  </Typography>
                  <Translate value={statusMessage} />
                  <Typography className={classes.statusMessageTextBold}>
                    <Translate value="components.migrationToSecureEdge.notification.help" />
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        </Box>
        {!isMigrated && showButton && (
          <Box className={classes.button}>
            <Button
              onClick={() => {
                migrateStatus === 'not_started'
                  ? migrate_btn()
                  : redirectSecureEdge();
              }}
              disabled={migrateAction === 'prepare'}
              variant="contained"
              color="secondary"
            >
              {migrateStatus !== 'not_started' ? (
                <Translate
                  value={`components.migrationToSecureEdge.${migrateAction}Button`}
                />
              ) : (
                <Translate value="components.migrationToSecureEdge.migrateButton" />
              )}
            </Button>
          </Box>
        )}
      </Box>
    );
  }
}

export default withStyles(style, { name: 'StatusBanner' })(
  StatusBannerComponent
);
